// lib/session.js
import { api } from "./api";

let user = null;
let fetched = false;
let fetching = null;
const STALE_MS = 10 * 60 * 1000;
let lastAt = 0;

export function getUser() {
  return user;
}

export function clearSession() {
  user = null;
  fetched = false;
  lastAt = 0;
  fetching = null;
}

export async function getMeOnce({ force = false } = {}) {
  const stale = Date.now() - lastAt > STALE_MS;
  if (!force && fetched && !stale) return user;
  if (fetching) return fetching;

  fetching = api("/v1/me")
    .then(async (res) => {
      if (res.ok) {
        const json = await res.json();
        // ✅ 백엔드 포맷: { user, role }
        user = json?.user ? { ...json.user, role: json.role } : null;
        fetched = true;
        lastAt = Date.now();
        return user;
      } else {
        // 401 등 에러는 조용히 처리
        user = null;
        fetched = true;
        lastAt = Date.now();
        return null;
      }
    })
    .catch(() => {
      user = null;
      fetched = true;
      lastAt = Date.now();
      return null;
    })
    .finally(() => {
      fetching = null;
    });

  return fetching;
}
